"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[9660],{

/***/ 68806:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ AddToButton_AddToButton)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/compositions/buttons/AddToButton/components/AddToButtonBase/AddToButtonBase.tsx
var AddToButtonBase = __webpack_require__(69916);
// EXTERNAL MODULE: ./local_modules/analytics/context/index.ts
var context = __webpack_require__(5649);
// EXTERNAL MODULE: ./src/modules/queue/index.ts + 7 modules
var queue = __webpack_require__(11982);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(21182);
// EXTERNAL MODULE: ./src/compositions/buttons/AddToButton/util/useAddClickHandler.ts
var useAddClickHandler = __webpack_require__(2070);
;// CONCATENATED MODULE: ./src/compositions/buttons/AddToButton/components/AddToQueueButton/AddToQueueButton.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}







var AddToQueueButton = function(props) {
    var className = props.className, title = props.title, inlineIcon = props.inlineIcon, style = props.style, size = props.size, width = props.width, fullWidth = props.fullWidth, fullWidthOnMobile = props.fullWidthOnMobile, product = props.product, metadata = props.metadata, force = props.force, position = props.position, withNonAuthRedirect = props.withNonAuthRedirect, withNotification = props.withNotification, withErrorModals = props.withErrorModals, _props_withResubscribeFlow = props.withResubscribeFlow, withResubscribeFlow = _props_withResubscribeFlow === void 0 ? true : _props_withResubscribeFlow, withUpgradeFlow = props.withUpgradeFlow, _props_withCaseUpsellModal = props.withCaseUpsellModal, withCaseUpsellModal = _props_withCaseUpsellModal === void 0 ? true : _props_withCaseUpsellModal, isAddedFromProps = props.isAdded, onClick = props.onClick, tmp = props["data-testid"], dataTestId = tmp === void 0 ? "addToQueueButton" : tmp;
    var _useQueueAddItems = _sliced_to_array((0,queue/* useQueueAddItems */.Rx)(), 2), submit = _useQueueAddItems[0], isFetching = _useQueueAddItems[1].isFetching;
    var _useAddClickHandler = (0,useAddClickHandler/* default */.Z)(/*#__PURE__*/ _async_to_generator(function() {
        var _getAnalyticsContext, page, pageType;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    // TODO add event - added on 2021-11-26 by maddoger
                    _getAnalyticsContext = (0,context/* getAnalyticsContext */.cV)(), page = _getAnalyticsContext.page, pageType = _getAnalyticsContext.pageType;
                    return [
                        4,
                        submit({
                            product: product,
                            force: force,
                            position: position,
                            metadata: _object_spread({
                                page: page,
                                pageType: pageType
                            }, metadata)
                        }, {
                            withErrorModals: withErrorModals,
                            withNonAuthRedirect: withNonAuthRedirect,
                            withNotification: withNotification,
                            withResubscribeFlow: withResubscribeFlow,
                            withUpgradeFlow: withUpgradeFlow,
                            withCaseUpsellModal: withCaseUpsellModal
                        })
                    ];
                case 1:
                    _state.sent();
                    if (typeof onClick === "function") {
                        onClick();
                    }
                    return [
                        2
                    ];
            }
        });
    })), isAddedAfterClick = _useAddClickHandler.isAdded, handleClick = _useAddClickHandler.handleClick;
    /* some products don't have tradingItem when they are out of stock, so we disable the button in this case */ var isOutOfStock = !product.tradingItemId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToButtonBase/* default */.Z, {
        className: className,
        style: style,
        size: size,
        width: width,
        fullWidth: fullWidth,
        fullWidthOnMobile: fullWidthOnMobile,
        title: title || messages/* default */.Z.addToQueue,
        inlineIcon: inlineIcon,
        isAdded: isAddedFromProps !== null && isAddedFromProps !== void 0 ? isAddedFromProps : isAddedAfterClick,
        loading: isFetching,
        isOutOfStock: isOutOfStock,
        disabled: isOutOfStock,
        onClick: handleClick,
        "data-testid": dataTestId
    });
};
/* harmony default export */ const AddToQueueButton_AddToQueueButton = (AddToQueueButton);

// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/components/inputs/Button/Button.tsx + 6 modules
var Button = __webpack_require__(23796);
;// CONCATENATED MODULE: ./src/compositions/buttons/AddToButton/components/AddToQueueTryItOldViewButton/messages.ts
/* harmony default export */ const AddToQueueTryItOldViewButton_messages = ({
    tryFragrance: {
        en: "Try this fragrance"
    }
});

;// CONCATENATED MODULE: ./src/compositions/buttons/AddToButton/components/AddToQueueTryItOldViewButton/AddToQueueTryItOldViewButton.tsx
function AddToQueueTryItOldViewButton_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function AddToQueueTryItOldViewButton_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function AddToQueueTryItOldViewButton_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function AddToQueueTryItOldViewButton_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                AddToQueueTryItOldViewButton_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                AddToQueueTryItOldViewButton_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function AddToQueueTryItOldViewButton_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AddToQueueTryItOldViewButton_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function AddToQueueTryItOldViewButton_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function AddToQueueTryItOldViewButton_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AddToQueueTryItOldViewButton_define_property(target, key, source[key]);
        });
    }
    return target;
}
function AddToQueueTryItOldViewButton_sliced_to_array(arr, i) {
    return AddToQueueTryItOldViewButton_array_with_holes(arr) || AddToQueueTryItOldViewButton_iterable_to_array_limit(arr, i) || AddToQueueTryItOldViewButton_unsupported_iterable_to_array(arr, i) || AddToQueueTryItOldViewButton_non_iterable_rest();
}
function AddToQueueTryItOldViewButton_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return AddToQueueTryItOldViewButton_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AddToQueueTryItOldViewButton_array_like_to_array(o, minLen);
}
function AddToQueueTryItOldViewButton_ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}








var AddToQueueTryItOldViewButton = function(props) {
    var className = props.className, tmp = props["data-testid"], dataTestId = tmp === void 0 ? "addToQueueButton" : tmp, product = props.product, metadata = props.metadata, force = props.force, position = props.position, withNonAuthRedirect = props.withNonAuthRedirect, withNotification = props.withNotification, withErrorModals = props.withErrorModals, _props_withResubscribeFlow = props.withResubscribeFlow, withResubscribeFlow = _props_withResubscribeFlow === void 0 ? true : _props_withResubscribeFlow, onClick = props.onClick;
    var _useQueueAddItems = AddToQueueTryItOldViewButton_sliced_to_array((0,queue/* useQueueAddItems */.Rx)(), 2), submit = _useQueueAddItems[0], isFetching = _useQueueAddItems[1].isFetching;
    var _useAddClickHandler = (0,useAddClickHandler/* default */.Z)(/*#__PURE__*/ AddToQueueTryItOldViewButton_async_to_generator(function() {
        var _getAnalyticsContext, page, pageType;
        return AddToQueueTryItOldViewButton_ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _getAnalyticsContext = (0,context/* getAnalyticsContext */.cV)(), page = _getAnalyticsContext.page, pageType = _getAnalyticsContext.pageType;
                    return [
                        4,
                        submit({
                            product: product,
                            force: force,
                            position: position,
                            metadata: AddToQueueTryItOldViewButton_object_spread({
                                page: page,
                                pageType: pageType
                            }, metadata)
                        }, {
                            withErrorModals: withErrorModals,
                            withNonAuthRedirect: withNonAuthRedirect,
                            withNotification: withNotification,
                            withResubscribeFlow: withResubscribeFlow
                        })
                    ];
                case 1:
                    _state.sent();
                    if (typeof onClick === "function") {
                        onClick();
                    }
                    return [
                        2
                    ];
            }
        });
    })), isAdded = _useAddClickHandler.isAdded, handleClick = _useAddClickHandler.handleClick;
    /* some products don't have tradingItem when they are out of stock, so we disable the button in this case */ var isOutOfStock = !product.tradingItemId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                className: "mb-24 bg-gold-30"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: (0,clsx/* default */.Z)("h-s24 text-t4", isAdded ? "text-gold-70" : "hover:text-gold-30"),
                title: isAdded ? messages/* default */.Z.added : AddToQueueTryItOldViewButton_messages.tryFragrance,
                leftIcon: isAdded ? "24/checkmark-in-circle" : isFetching ? "20/loader" : "24/plus-in-circle",
                size: null,
                style: null,
                loading: isFetching,
                disabled: isOutOfStock,
                onClick: handleClick,
                fullWidth: true,
                "data-testid": dataTestId
            })
        ]
    });
};
/* harmony default export */ const AddToQueueTryItOldViewButton_AddToQueueTryItOldViewButton = (AddToQueueTryItOldViewButton);

// EXTERNAL MODULE: ./src/compositions/buttons/AddToButton/components/AddToCartButton/AddToCartButton.tsx
var AddToCartButton = __webpack_require__(45464);
;// CONCATENATED MODULE: ./src/compositions/buttons/AddToButton/AddToButton.tsx
function AddToButton_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AddToButton_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AddToButton_define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






// this button isn't very optimal from re-rendering standpoint, but it usually sits in React.memo(ProductCard)
var AddToButton = function(props) {
    var type = props.type, rest = _object_without_properties(props, [
        "type"
    ]);
    var className = rest.className, dataTestId = rest["data-testid"];
    if (type === "cart") {
        var product = props.product, size = props.size, style = props.style, width = props.width, fullWidth = props.fullWidth, fullWidthOnMobile = props.fullWidthOnMobile, metadata = props.metadata, title = props.title, withNotification = props.withNotification, withErrorModals = props.withErrorModals, withRedirectToCheckout = props.withRedirectToCheckout, onClick = props.onClick;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartButton/* default */.Z, {
            className: className,
            style: style,
            size: size,
            width: width,
            fullWidth: fullWidth,
            fullWidthOnMobile: fullWidthOnMobile,
            product: product,
            metadata: metadata,
            title: title,
            withErrorModals: withErrorModals,
            withNotification: withNotification,
            withRedirectToCheckout: withRedirectToCheckout,
            onClick: onClick,
            "data-testid": dataTestId
        });
    }
    if (type === "custom") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToButtonBase/* default */.Z, AddToButton_object_spread({}, rest));
    }
    // queue
    var product1 = props.product, metadata1 = props.metadata, force = props.force, position = props.position, withErrorModals1 = props.withErrorModals, withNotification1 = props.withNotification, withNonAuthRedirect = props.withNonAuthRedirect, withCaseUpsellModal = props.withCaseUpsellModal, withUpgradeFlow = props.withUpgradeFlow, onClick1 = props.onClick;
    if (type === "queueTryItOldView") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToQueueTryItOldViewButton_AddToQueueTryItOldViewButton, {
            className: className,
            product: product1,
            metadata: metadata1,
            force: force,
            position: position,
            withErrorModals: withErrorModals1,
            withNotification: withNotification1,
            withNonAuthRedirect: withNonAuthRedirect,
            onClick: onClick1,
            "data-testid": dataTestId
        });
    }
    var title1 = props.title, inlineIcon = props.inlineIcon, size1 = props.size, style1 = props.style, width1 = props.width, fullWidth1 = props.fullWidth, fullWidthOnMobile1 = props.fullWidthOnMobile, isAdded = props.isAdded;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToQueueButton_AddToQueueButton, {
        className: className,
        title: title1,
        inlineIcon: inlineIcon,
        style: style1,
        size: size1,
        width: width1,
        fullWidth: fullWidth1,
        fullWidthOnMobile: fullWidthOnMobile1,
        product: product1,
        metadata: metadata1,
        force: force,
        position: position,
        withErrorModals: withErrorModals1,
        withNotification: withNotification1,
        withNonAuthRedirect: withNonAuthRedirect,
        withCaseUpsellModal: withCaseUpsellModal,
        withUpgradeFlow: withUpgradeFlow,
        isAdded: isAdded,
        onClick: onClick1,
        "data-testid": dataTestId
    });
};
/* harmony default export */ const AddToButton_AddToButton = (AddToButton);


/***/ }),

/***/ 69916:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52983);
/* harmony import */ var intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17696);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21182);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23796);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24959);






var AddToButtonBase = function(props) {
    var children = props.children, className = props.className, to = props.to, _props_style = props.style, style = _props_style === void 0 ? "primary" : _props_style, _props_size = props.size, size = _props_size === void 0 ? 48 : _props_size, width = props.width, fullWidth = props.fullWidth, fullWidthOnMobile = props.fullWidthOnMobile, title = props.title, inlineIcon = props.inlineIcon, addedMessage = props.addedMessage, isAdded = props.isAdded, isOutOfStock = props.isOutOfStock, disabled = props.disabled, loading = props.loading, onClick = props.onClick, dataTestId = props["data-testid"];
    var content;
    if (children) {
        content = children;
    } else if (isOutOfStock) {
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            value: components_inputs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z.outOfStock
        });
    } else if (isAdded) {
        var addedColor = style === "primary" ? "text-gold-30" : "text-gold-70";
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "flex items-center justify-center ".concat(addedColor),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    value: addedMessage || components_inputs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z.added
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                    className: "ml-4",
                    name: "24/checkmark"
                })
            ]
        });
    } else {
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    value: title
                }),
                Boolean(inlineIcon) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                    className: "ml-4",
                    name: inlineIcon
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_inputs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: className,
        to: to,
        style: style,
        size: size,
        width: width,
        fullWidth: fullWidth,
        fullWidthOnMobile: fullWidthOnMobile,
        disabled: disabled,
        loading: loading,
        "data-testid": dataTestId,
        onClick: onClick,
        children: content
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AddToButtonBase);


/***/ }),

/***/ 45464:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33273);
/* harmony import */ var core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52983);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5649);
/* harmony import */ var modals__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31978);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50556);
/* harmony import */ var helpers_getters__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(67525);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68426);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51827);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86506);
/* harmony import */ var modules_cart__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65337);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21182);
/* harmony import */ var _util_useAddClickHandler__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2070);
/* harmony import */ var _AddToButtonBase_AddToButtonBase__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69916);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}













var AddToCartButton = function(props) {
    var children = props.children, className = props.className, style = props.style, size = props.size, width = props.width, fullWidth = props.fullWidth, fullWidthOnMobile = props.fullWidthOnMobile, product = props.product, metadata = props.metadata, _props_title = props.title, title = _props_title === void 0 ? components_inputs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.addToCart : _props_title, _props_withErrorModals = props.withErrorModals, withErrorModals = _props_withErrorModals === void 0 ? true : _props_withErrorModals, _props_withNotification = props.withNotification, withNotification = _props_withNotification === void 0 ? true : _props_withNotification, _props_withRedirectToCheckout = props.withRedirectToCheckout, withRedirectToCheckout = _props_withRedirectToCheckout === void 0 ? false : _props_withRedirectToCheckout, onClick = props.onClick, tmp = props["data-testid"], dataTestId = tmp === void 0 ? "addToCartButton" : tmp;
    var shownPopups = (0,modules_user__WEBPACK_IMPORTED_MODULE_4__/* .useShownPopups */ .BP)().shownPopups;
    var _useCartAddProduct = _sliced_to_array((0,modules_cart__WEBPACK_IMPORTED_MODULE_5__/* .useCartAddProduct */ .H3)(), 2), submit = _useCartAddProduct[0], isFetching = _useCartAddProduct[1].isFetching;
    var isCaseUpsellModalEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z.features.caseUpsellAddToCart);
    var isHereticCaseUpsellModalEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z.features.caseUpsellHeretic);
    var isCartAutoOpenEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z.abTests.cartNotificationDesignUpdate) !== "b";
    var _useAddClickHandler = (0,_util_useAddClickHandler__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(/*#__PURE__*/ _async_to_generator(function() {
        var _shownPopups_driftRefillClipDisclaimerModal, openCaseUpsellModal, openDriftRefillClipDisclaimerModal, _getAnalyticsContext, page, pageType, processSubmit, cookieCondition, cookieCondition1;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _getAnalyticsContext = (0,analytics__WEBPACK_IMPORTED_MODULE_10__/* .getAnalyticsContext */ .cV)(), page = _getAnalyticsContext.page, pageType = _getAnalyticsContext.pageType;
                    processSubmit = function() {
                        var _ref = _async_to_generator(function() {
                            var withCaseUpsellModal, withCartOpen;
                            return _ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        withCaseUpsellModal = Boolean(openCaseUpsellModal);
                                        withCartOpen = props.withCartOpen !== undefined ? props.withCartOpen : isCartAutoOpenEnabled && !withRedirectToCheckout && !withCaseUpsellModal;
                                        return [
                                            4,
                                            submit({
                                                product: product,
                                                metadata: _object_spread({
                                                    page: page,
                                                    pageType: pageType
                                                }, metadata)
                                            }, {
                                                withErrorModals: withErrorModals,
                                                withNotification: !withCaseUpsellModal && !withCartOpen && withNotification,
                                                withRedirectToCheckout: withRedirectToCheckout,
                                                withCartOpen: withCartOpen
                                            })
                                        ];
                                    case 1:
                                        _state.sent();
                                        if (typeof onClick === "function") {
                                            onClick();
                                        }
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function processSubmit() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    if (product.isRefill && !((_shownPopups_driftRefillClipDisclaimerModal = shownPopups["driftRefillClipDisclaimerModal"]) === null || _shownPopups_driftRefillClipDisclaimerModal === void 0 ? void 0 : _shownPopups_driftRefillClipDisclaimerModal.lastUpdated)) {
                        void (0,modals__WEBPACK_IMPORTED_MODULE_11__/* .preloadModal */ .My)("driftRefillClipDisclaimerModal");
                        openDriftRefillClipDisclaimerModal = function() {
                            (0,modals__WEBPACK_IMPORTED_MODULE_11__/* .openModal */ .h7)("driftRefillClipDisclaimerModal", {
                                productId: product.productId,
                                tradingItemId: product.tradingItemId,
                                onClose: processSubmit
                            });
                        };
                    } else if (product.isVial && !product.is1_5mlVial && !product.isLimitedDrop) {
                        if (isHereticCaseUpsellModalEnabled && product.brand.toUpperCase().startsWith("HERETIC")) {
                            cookieCondition = (0,helpers_getters__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                                cookieName: helpers__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z.cookieNames.isHereticCaseUpsellModalShown,
                                countPerDay: 5
                            });
                            if (cookieCondition.isVisible) {
                                void (0,modals__WEBPACK_IMPORTED_MODULE_11__/* .preloadModal */ .My)("hereticCaseUpsellModal");
                                openCaseUpsellModal = function() {
                                    (0,modals__WEBPACK_IMPORTED_MODULE_11__/* .openModal */ .h7)("hereticCaseUpsellModal", {
                                        product: product,
                                        addTo: "cart",
                                        onClose: cookieCondition.onClose
                                    });
                                };
                            }
                        } else if (isCaseUpsellModalEnabled) {
                            cookieCondition1 = (0,helpers_getters__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                                cookieName: helpers__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z.cookieNames.isAddToCartCaseUpsellModalShown,
                                countPerDay: 3
                            });
                            if (cookieCondition1.isVisible) {
                                void (0,modals__WEBPACK_IMPORTED_MODULE_11__/* .preloadModal */ .My)("caseUpsellModal");
                                openCaseUpsellModal = function() {
                                    (0,modals__WEBPACK_IMPORTED_MODULE_11__/* .openModal */ .h7)("caseUpsellModal", {
                                        product: product,
                                        addTo: "cart",
                                        onClose: cookieCondition1.onClose
                                    });
                                };
                            }
                        }
                    }
                    if (!openDriftRefillClipDisclaimerModal) return [
                        3,
                        1
                    ];
                    openDriftRefillClipDisclaimerModal();
                    return [
                        3,
                        3
                    ];
                case 1:
                    return [
                        4,
                        processSubmit()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    if (openCaseUpsellModal) {
                        openCaseUpsellModal();
                    }
                    return [
                        2
                    ];
            }
        });
    })), isAdded = _useAddClickHandler.isAdded, handleClick = _useAddClickHandler.handleClick;
    /* some products don't have tradingItem when they are out of stock, so we disable the button in this case */ var isOutOfStock = !product.tradingItemId;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_AddToButtonBase_AddToButtonBase__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        className: className,
        style: style,
        size: size,
        width: width,
        fullWidth: fullWidth,
        fullWidthOnMobile: fullWidthOnMobile,
        title: title,
        isAdded: isAdded,
        loading: isFetching,
        disabled: isOutOfStock,
        isOutOfStock: isOutOfStock,
        onClick: handleClick,
        "data-testid": dataTestId,
        children: children
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AddToCartButton);


/***/ }),

/***/ 2070:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85183);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73598);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52983);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83901);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}




var useAddClickHandler = function(onClick) {
    var _useState = _sliced_to_array((0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), 2), isAdded = _useState[0], setAddedState = _useState[1];
    var timeoutRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var onClickRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(onClick);
    onClickRef.current = onClick;
    var handleClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ _async_to_generator(function() {
        var error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    if (!(typeof onClickRef.current === "function")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        onClickRef.current()
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    setAddedState(true);
                    timeoutRef.current = setTimeout(function() {
                        setAddedState(false);
                    }, 3000);
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        (0,helpers__WEBPACK_IMPORTED_MODULE_3__/* .processError */ .wY)(error)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        return function() {
            return clearTimeout(timeoutRef.current);
        };
    }, []);
    return {
        isAdded: isAdded,
        handleClick: handleClick
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useAddClickHandler);


/***/ })

}]);